import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized } from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"
// planning actions

export const POST_PLANNING_PENDING = "POST_PLANNING_PENDING";
export const POST_PLANNING_REJECTED = "POST_PLANNING_REJECTED";
export const POST_PLANNING_FULFILLED = "POST_PLANNING_FULFILLED";
export const GET_PLANNING_PENDING = "GET_PLANNING_PENDING";
export const GET_PLANNING_REJECTED = "GET_PLANNING_REJECTED";
export const GET_PLANNING_FULFILLED = "GET_PLANNING_FULFILLED";
const loading = (state = {}, { type }) => {
  switch (type) {
    case POST_PLANNING_PENDING:
    case GET_PLANNING_PENDING:
      return true;
    case POST_PLANNING_REJECTED:
    case POST_PLANNING_FULFILLED:
    case GET_PLANNING_PENDING:
    case GET_PLANNING_PENDING:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case POST_PLANNING_PENDING:
    case POST_PLANNING_FULFILLED:
    case GET_PLANNING_PENDING:
    case GET_PLANNING_FULFILLED:
      return null;
    case POST_PLANNING_REJECTED:
    case GET_PLANNING_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {

  switch (type) {
    case POST_PLANNING_FULFILLED:
    case GET_PLANNING_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    case GET_PLANNING_PENDING:
      return null;

    default:
      return state;
  }
};

// PLANNING reducer
export default combineReducers({ loading, error, data });

export const postPlanningSimple = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: POST_PLANNING_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: POST_PLANNING_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const getPlanningSimple = (tok, id) => {
  return (dispatch) => {
    dispatch({ type: GET_PLANNING_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/calendrier/absences`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })

    response.then((res) => {

      dispatch({ type: GET_PLANNING_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_PLANNING_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
